module.exports = __webpack_public_path__ + "static/media/MediumIcon.42a8de32.svg";